module.exports = __webpack_public_path__ + "img/zentao.1c1c1b0c.png";